import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { useProjectId } from 'owa-timestream-asset-sdk';
import { getProject, isTemplateProject } from 'owa-timestream-store';
import { closeProjectPreview, selectTemplateFromPreview } from 'owa-timestream-projectmanager';
import getCanvasPreviewAriaLabel from '../util/getCanvasPreviewAriaLabel';
import loc from 'owa-localize';
import { CreateNew } from 'owa-locstrings/lib/strings/createnew.locstring.json';
import { cancel } from 'owa-locstrings/lib/strings/cancel.locstring.json';

export default observer(function TimeStreamCanvasPreviewInfo() {
    const projectId = useProjectId();
    const { name, description, templateType } = getProject(projectId);

    const onCreateClicked = React.useCallback(() => {
        closeProjectPreview();
        if (isTemplateProject(projectId)) {
            selectTemplateFromPreview(templateType);
        }
    }, [projectId, templateType]);

    return (
        <div className={styles.previewFooterContainer}>
            <div
                className={styles.previewNameAndDescription}
                role="dialog"
                aria-label={getCanvasPreviewAriaLabel(projectId, name, description)}
                tabIndex={0}>
                <div className={styles.previewHeader}>{name}</div>
                <div>{description}</div>
            </div>
            <div className={styles.previewActionButtons}>
                <PrimaryButton
                    className={styles.previewCreateButton}
                    text={loc(CreateNew)}
                    onClick={onCreateClicked}
                />
                <DefaultButton text={loc(cancel)} onClick={closeProjectPreview} />
            </div>
        </div>
    );
});
